import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { enviroment } from 'src/environments/environment';
import { CreateFileUploadRes, ShareFileLinkRes, SharedFileInfoRes } from '../model/response/shared-file';

/**
 * Link público de arquivo do usuário. Os headers de auth ficam com o interceptor
 * (cobre /user/ e /global/): assim a chamada anônima da página pública sai sem
 * Authorization, em vez de um "Bearer " vazio.
 */
@Injectable({ providedIn: 'root' })
export class SharedFileService {
  private readonly apiUrl = enviroment.BASE_URL_API;

  constructor(private http: HttpClient) {}

  /** Gera um código novo a cada chamada; os anteriores seguem valendo até expirar. */
  createLink(userId: string, fileId: string): Observable<ShareFileLinkRes> {
    return this.http.post<ShareFileLinkRes>(`${this.apiUrl}/user/${userId}/shared/file/${fileId}`, null);
  }

  getInfo(code: string): Observable<SharedFileInfoRes> {
    return this.http.get<SharedFileInfoRes>(`${this.apiUrl}/global/shared/file/${encodeURIComponent(code)}`);
  }

  /** Copia o arquivo para a conta do usuário logado, como arquivo solto. */
  saveToAccount(userId: string, code: string): Observable<CreateFileUploadRes> {
    return this.http.post<CreateFileUploadRes>(
      `${this.apiUrl}/user/${userId}/shared/file/${encodeURIComponent(code)}/save`,
      null,
    );
  }

  /** O download é navegação (302 → S3), não chamada por HttpClient. */
  downloadUrl(code: string): string {
    return `${this.apiUrl}/global/download/${encodeURIComponent(code)}`;
  }

  /** URL da página pública no domínio da aplicação. */
  pageUrl(code: string): string {
    return `${enviroment.BASE_URL}/shared?code=${encodeURIComponent(code)}`;
  }
}
